import clsx from 'clsx';
import isEqual from 'lodash/isEqual';
import React, { useRef, useEffect } from 'react';
import { useMeasure } from 'react-use';
import { TWO_COLUMN_LAYOUT } from '../settings';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
export const DEFAULT_LAYOUT_SETTINGS = {
  isTwoColumnLayout: false
};

const EditorLayout = _ref => {
  let {
    className,
    onLayoutChange,
    children
  } = _ref;
  const [ref, {
    width
  }] = useMeasure();
  const layoutSettings = useRef(DEFAULT_LAYOUT_SETTINGS); // Publish changes to layout settings
  // so that they can be broadcast to components
  // within the layout

  useEffect(() => {
    if (!onLayoutChange) return;
    const isTwoColumnLayout = width >= TWO_COLUMN_LAYOUT;
    const updatedLayoutSettings = {
      isTwoColumnLayout
    };

    if (!isEqual(updatedLayoutSettings, layoutSettings.current)) {
      onLayoutChange(updatedLayoutSettings);
      layoutSettings.current = updatedLayoutSettings;
    }
  }, [width, onLayoutChange]);
  return /*#__PURE__*/_jsx("div", {
    // @ts-ignore
    ref: ref,
    className: clsx(styles.container, className || ''),
    id: "scroll-container",
    children: children
  });
};

export default EditorLayout;
export { styles };